import { useEffect, useState, useContext } from 'react';
import { BackendAccessContext } from 'Backend';
import { getCurrentCompanyId } from 'Lib/Utils';
import PropTypes from 'prop-types';
import './Prism.css';
import Button from 'Components/UI_Library/FormElements/Button';
import CloseBtn from 'Components/UI_Library/Icons/CloseBtn';

import NoAccessSection from 'Components/UI_Library/Prism/NoAccessSection';
import Modal from 'react-modal';

const pricingTiers = ['freeTier', 'basicTier', 'premiumTier'];

const Prism = (props) => {
    const [loaded, setloaded] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const { prism } = useContext(BackendAccessContext);
    const [tier, settier] = useState('');
    const [modalopen, setmodalopen] = useState(false);
    const [custommessage, setcustommessage] = useState('');
    const niceFeatureName = !props.niceFeatureName
        ? props.featureName
              .split(/(?=[A-Z])/)
              .join(' ')
              .toLowerCase()
        : props.niceFeatureName;

    useEffect(() => {
        if ('visible' in props && !props.pageToggle) return;
        const CompanyId = getCurrentCompanyId();

        const featureName = prism?.[props.featureName];

        const companyhasFeature = featureName?.companies?.includes(CompanyId); // check if company has access to feature
        const featureIsInTier = pricingTiers.find((i) => featureName?.[i]); // check if any pricing tier flags are on
        const featureIsInBeta = companyhasFeature && featureName.beta;

        settier(featureIsInTier ? featureIsInTier.replace('Tier', '') : '');
        setcustommessage(props.featureName === 'UrgentMessage' && featureName?.message ? featureName.message : ''); // custom message from prism DB, currently used for UrgentMessage feature

        if (featureName) {
            setloaded(true);
        }

        // enable access for paytron employees, or if feature is in any of the pricing tiers, or if it's in beta
        if (featureIsInTier || featureIsInBeta) {
            setEnabled(true);
        } else {
            setEnabled(featureName?.public);
        }
    }, [prism, props, props.pageToggle]);

    if (!loaded) return null;

    if (enabled) {
        if (custommessage) {
            return <div className="urgent-message">{custommessage}</div>;
        }
        return <>{props.children}</>;
    } else {
        // show an alternative version of the component if they don't have access
        if (props.fallback) {
            return props.fallback;
        }
        if (!props.showModal) {
            return (
                <NoAccessSection
                    sentence={
                        <span>
                            <span style={{ textTransform: 'capitalize' }}>{tier}</span> plan required
                        </span>
                    }
                />
            );
        }
        return (
            <>
                <Button onClick={() => setmodalopen(true)} text="Upgrade" type="primary-thin" />
                {modalopen && (
                    <Modal
                        key={props.featureName}
                        isOpen={modalopen}
                        onRequestClose={() => setmodalopen(false)}
                        className="modal fade show"
                        shouldCloseOnOverlayClick
                        overlayClassName="mfp-bg"
                        ariaHideApp={false}
                    >
                        <div
                            className="modal-dialog modal-dialog-medium modal-dialog-centered no-access-modal"
                            role="document"
                        >
                            <div className="modal-content shadow">
                                <CloseBtn
                                    colour="blue"
                                    className="no-access-close"
                                    onClick={() => setmodalopen(false)}
                                />
                                <div className="modal-body">
                                    <NoAccessSection
                                        sentence={
                                            <span>
                                                The {niceFeatureName} feature is available as a part of the {tier} tier,
                                                <br /> please upgrade your subscription
                                            </span>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}
            </>
        );
    }
};

Prism.defaultProps = {
    showModal: true,
};

Prism.propTypes = {
    featureName: PropTypes.string.isRequired, // The feature as it is in the db
    niceFeatureName: PropTypes.string, // a nice label version of the feature name
    children: PropTypes.node.isRequired, // The content rendered inside <Prism>
    fallback: PropTypes.element, // Custom content rendered when user does not have access to feature
    showModal: PropTypes.bool, // toggle weather to render the button+modal, or just the <NoAccessSection /> component
    pageToggle: PropTypes.bool, // used to check visibility of component
};

export default Prism;
